import Pointer from './Pointer'

export default Pointer
